import vectorArt from "../../assets/signup-screen4.svg";
import dotsBottom from "../../assets/login-dots-bottom.svg";
import dotsTop from "../../assets/login-dots-top.svg";
import logo from "../../assets/top-nav-logo.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  saveSelectedOrg,
  setAllOrgsDetails,
} from "../features/account/account";
import Button from "../design/Button";
import colors from "../design/colors";
import './commonStyles.css';
import { JService } from "../api-service/ApiService";
import {
  CustomInput,
  CustomSelect,
} from "../design/components/customComponents";
import { enqueueSnackbar } from "notistack";

const teamSizeChoices = [{ value: 1, displayValue: "1-10" }, { value: 2, displayValue: "11-50" }, { value: 3, displayValue: "51-100" }, { value: 4, displayValue: "100 or more" },]
const useCaseChoices = [{ value: "Customer support", displayValue: "Customer support" }, { value: "Recruitment", displayValue: "Recruitment" }, { value: "Sales", displayValue: "Sales" }, { value: "Other", displayValue: "Other" }]

export default function SignupScreen4() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [organizationName, setOrganizationName] = useState({
    value: "",
    error: null,
  });
  const [teamSize, setTeamSize] = useState(null);
  const [selectedUseCase, setSelectedUseCase] = useState("");
  const [showLoader, setShowLoader] = useState(false);


  const handleCompanyNameChange = (e) => {
    setOrganizationName((prev) => ({ ...prev, value: e.target.value }));
  };
  const handleFocus = () => {
    setOrganizationName((prev) => ({ ...prev, error: null }));
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    // validation
    if (organizationName?.value?.trim()?.length === 0) {
      setOrganizationName((prev) => ({
        ...prev,
        error: "Please enter a valid name",
      }));
      return;
    }
    let errors = null;
    setShowLoader(true);
    JService.patch(
      "/api/v1/auth/update-organization/",
      JSON.stringify({
        company: organizationName?.value,
        use_case: selectedUseCase,
        team_size: teamSize
      })
    )
      .then((res) => {
        if (!res?.success) {
          if (res?.details) errors = res?.details;
          throw new Error(
            res?.message || res?.detail || "Could not update company details",
          );
        }
        enqueueSnackbar(res?.message || "Updated company details", { variant: "success" })

        dispatch(setAllOrgsDetails([res?.data]));
        dispatch(saveSelectedOrg(res?.data?.id));
        navigate("/signup/account-type");
      })
      .catch((err) => {
        if (errors && errors?.company) {
          setOrganizationName((prev) => ({
            ...prev,
            error: Array.isArray(errors?.company)
              ? errors?.company[0]
              : errors.company,
          }));
        } else
          enqueueSnackbar(err?.message || "Could not update company details", {
            variant: "error",
          });
      })
      .finally(() => {
        setShowLoader(false);
        if (!errors || !errors?.company)
          setOrganizationName({ value: "", error: null });
        setSelectedUseCase("");
        setTeamSize(null);
      });
  };

  return (
    <div className="signup-screen-container nc-gray-900">
      <div className="signup-art">
        <a href="https://frejun.com/" target="_blank" rel="noopener noreferrer"> <img src={logo} alt="Logo" /></a>
        <img src={dotsTop} />
        <img src={vectorArt} />
        <img src={dotsBottom} />
      </div>
      <div className="signup-screen2-form">
        <p className="title medium-font t5">Company details</p>
        <form>
          <CustomInput
            label='Company name'
            type='text' name='company'
            value={organizationName}
            handleChange={handleCompanyNameChange}
            handleFocus={handleFocus}
          />
          <div className="select-container">
            <CustomSelect
              label="Team size"
              value={teamSize}
              handleChange={(e) => setTeamSize(e.target.value)}
              renderVal={(val) => {
                return (
                  val ? <span className="nc-gray-900 t7 regular-font">
                    {teamSizeChoices.find(elem => elem.value === val)?.displayValue}
                  </span>
                    : <span className="nc-gray-400 t7 regular-font"> Select team size </span>
                )
              }}
              options={teamSizeChoices}
            />
          </div>
          <div className="select-container">
            <CustomSelect
              label="Planning to use FreJun for?"
              value={selectedUseCase}
              handleChange={(e) => setSelectedUseCase(e.target.value)}
              options={useCaseChoices}
              defaultValue="Select use"
            />
          </div>
          <div className="buttons-container btnscreen2">
            <Button
              disabled={
                !organizationName?.value ||
                organizationName?.value?.trim()?.length === 0 ||
                !selectedUseCase ||
                !teamSize
              }
              icon={{ startIcon: null, endIcon: null }}
              hierarchy="green"
              variant="contained"
              buttonText="Next"
              isLoading={showLoader}
              onClick={handleSubmit}
              spanStyles={{ width: '100%' }}
              styleOverride={{
                padding: '8px 40px',
                width: '100%',
                border: `1px solid ${!organizationName?.value ||
                  organizationName?.value?.trim()?.length === 0 ||
                  !selectedUseCase
                  ? colors.nc_gray_300
                  : "none"
                  }`,
                float: 'right'
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
}
